import React from 'react';
import { Form as AntForm, FormProps as AntFormProps } from 'antd';

// ============================================================================
// ESTILOS
// ============================================================================
import { StyledForm, StyledFormItem } from './Form.styles';

// ============================================================================
// TIPOS E INTERFACES
// ============================================================================

type FormProps = Omit<AntFormProps, 'children'> & { children?: React.ReactNode };

// ============================================================================
// COMPONENTE
// ============================================================================

const Form: React.FC<FormProps> & {
  useForm: typeof AntForm.useForm;
  useWatch: typeof AntForm.useWatch;
  Item: typeof StyledFormItem;
  List: typeof AntForm.List;
  Provider: typeof AntForm.Provider;
  ErrorList: typeof AntForm.ErrorList;
} = (props: any) => <StyledForm {...props} />;

Form.useForm = AntForm.useForm;
Form.useWatch = AntForm.useWatch;
Form.Item = StyledFormItem;
Form.List = AntForm.List;
Form.Provider = AntForm.Provider;
Form.ErrorList = AntForm.ErrorList;

export default Form;
